import jQuery from 'jquery';
(window as any).$ = jQuery;
(window as any).jQuery = jQuery;
export default jQuery;
